// extracted by mini-css-extract-plugin
export default {"navigation":"gNB_navigation__DCdVO","active":"gNB_active__tABrM"};